import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { DOCUMENTS_SOURCE_NAME_MAX_LENGTH } from 'const/limits'
import { SubmissionError } from 'redux-form'
import {
  LeftSidebarView,
  ViewBody
} from 'components/Sidebar'
import withLeftSidebar, { LeftSidebarProps } from 'components/Sidebar/withLeftSidebar'
import AddDocumentTemplateSourceForm from './AddDocumentTemplateSourceForm'
import requestAddDocumentTemplateSource from 'store/sagas/requestAddDocumentTemplateSource'
import { useDispatch } from 'react-redux'

const AddDocumentTemplateSource: React.FC<LeftSidebarProps> = ({
  leftSidebar
}) => {
  const intl = useIntl()

  const dispatch = useDispatch()

  const cancelForm = () => {
    leftSidebar.pop()
  }

  const handleFormSubmit = ({ name, pluginForm }) => {
    if (!name) {
      throw new SubmissionError({
        name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' }),
        _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_EMPTY' })
      })
    } else if (name.length > DOCUMENTS_SOURCE_NAME_MAX_LENGTH) {
      const error = intl.formatMessage(
        { id: 'DOCUMENTS_SOURCES_NAME_TOO_LONG' },
        { limit: DOCUMENTS_SOURCE_NAME_MAX_LENGTH }
      )

      throw new SubmissionError({
        name: error,
        _error: error
      })
    }

    return dispatch<any>(requestAddDocumentTemplateSource({
      name,
      identifier: pluginForm?.identifier,
      args: pluginForm?.args,
    })).then(() => {
      cancelForm()
    }).catch(error => {
      if (error.code === 300) {
        throw new SubmissionError({
          name: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' }),
          _error: intl.formatMessage({ id: 'DOCUMENTS_SOURCES_NAME_DUPLICATE' })
        })
      } else {
        throw error
      }
    })
  }

  return (
    <LeftSidebarView
      title={<FormattedMessage id='DOCUMENT_TEMPLATE_SOURCES_ADD' />}
    >
      <ViewBody>
        <AddDocumentTemplateSourceForm
          onSubmit={handleFormSubmit}
          onCancelClick={cancelForm}
        />
      </ViewBody>
    </LeftSidebarView>
  )
}

export default withLeftSidebar(AddDocumentTemplateSource)